export const calculateColumnNumber = (
  xPosition: number,
  columnWidth: number
): number =>
  Math.ceil(xPosition * 100) / 100 >= columnWidth
    ? Math.round(xPosition / columnWidth) + 1
    : 1
